document.addEventListener("DOMContentLoaded", function() {

	let menu_open = false;
	let sub_menu_open = false;

	function navigation_keyboard_traversal(event) {

		//if the button pressed is one we're using to navigate
		if(["Tab", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(event.code)) { 

			//if we're tabbing and the menu isn't yet open, we shouldn't change any behaviour
			if(!menu_open && event.code == 'Tab') {
				//bail
				return;
			}

			//prevent any jumping around
			event.preventDefault();

			//if we're currently using the keyboard to navigate
			if(document.body.classList.contains('show-focus-outlines')) {

				let parent = event.target.parentNode;
				let first_element = parent.children[1] ? parent.children[1].children[0].children[0] : null;
				let prev_element = event.target.parentNode.previousElementSibling ? event.target.parentNode.previousElementSibling.children[0] : null;
				let next_element = event.target.parentNode.nextElementSibling ? event.target.parentNode.nextElementSibling.children[0] : null;
				
				let megamenu = false;
				let megamenu_nested = false;

				//go up 10 levels from the current element
				for(let i = 0; i < 10; i++) {
					for (ii = parent; ii; ii = ii.parentNode) {

						//if we find the bottom bar
						if(ii.id && ii.id == 'header-bottom-bar') {

							//flag that this is a mega menu	
							megamenu = ii;
							break;
						}
					}
				}

				//if we're in a megamenu
				if(megamenu) {

					//attempt to figure out if we're in a nested ul
					try {
						//attempt to find a nested ul
						megamenu_nested = parent.children[1].classList.contains('mega-nested-menu');

						//if we've found it
						if(megamenu_nested) {

							//update the next element
							next_element = parent.children[1].children[0].children[0];
						}
					} catch(e) {}

					//if we're not in a nested ul
					if(!megamenu_nested) {

						//attempt to set the next element as if it's top level
						try {
							next_element = parent.children[1].children[0].children[0].children[0];
						} catch(e) {
							//previous element is shared regardless of whether we're jumping a column or not
							prev_element = parent.previousElementSibling ? parent.previousElementSibling.children[0] : false;

							//if we have a next sibling, we're still inside the ul and there's another link to move to
							if(parent.nextElementSibling) {
								next_element = parent.nextElementSibling.children[0];
							} else { //otherwise we need to prepare jump across to the next column

								//if this is inside the nested menu
								if(parent.parentNode.classList.contains('mega-nested-menu')) {
									next_element = parent.parentNode.parentNode.nextElementSibling ? parent.parentNode.parentNode.nextElementSibling.children[0] : false;
								} else { //otherwise it's the end of a standard menu and we shouldn't proceed
									next_element = false;
								}
							}
						}
					}
				}

				switch(event.code) {
					case "ArrowDown":

						//if the menu is not open
						if(!menu_open && parent.classList.contains('menu-item-has-children')) {

							//open it
							parent.classList.add('keyboard-nav-toggle');
							menu_open = true;

							setTimeout(function() {

								//focus on the first element in this dropdown
								first_element.focus();
							}, 100);

						} else if(next_element) { //otherwise we're moving down the list

							//focus on the next element
							next_element.focus();
						}
					break;
					case 'ArrowRight':

						//if the arrow right button was triggered but there's no parent menu open
						if(!menu_open) {

							//this shouldn't perform any function, so break early
							break;
						}

						//if this is a new dropdown link and the sub menu is not open
						if(parent.classList.contains('menu-item-has-children') && !sub_menu_open) {

							//open the sub menu
							parent.classList.add('keyboard-nav-toggle');
							sub_menu_open = true;

							//focus on the first element in this dropdown
							first_element.focus();
						}
					break;
					case 'ArrowUp':
					case 'ArrowLeft':

						//if the arrow left button was triggered but there's no sub menu open
						if(event.code == "ArrowLeft" && !sub_menu_open) {

							//this shouldn't perform any function, so break early
							break;
						}

						//if we have a previous element to focus on
						if(prev_element) {

							//focus on it
							prev_element.focus();
						} else { //otherwise we're back at the top of the list

							//define our path to the current dropdown
							let dropdown = parent.parentNode.parentNode;

							//if we have a dropdown but it's the mega menu
							if(dropdown && dropdown.classList.contains('mega-sub-menu')) {

								//correct by moving up to the parent dropdown
								dropdown = dropdown.parentNode;
							}

							//close the dropdown
							navigation_close_dropdown(dropdown, dropdown.children[0]);
						}
					break;
					case "Tab":
						
						//define our path to the current dropdown
						let dropdown = parent.parentNode.parentNode;

						next_element = dropdown.nextElementSibling ? dropdown.nextElementSibling.children[0] : false;

						//if we're inside a megamenu
						if(megamenu) {

							//find the currently open dropdown
							let open_menu = megamenu.getElementsByClassName('keyboard-nav-toggle')[0];

							//update the dropdown to the top level link
							dropdown = open_menu;

							//get the next top level element
							next_element = open_menu.nextElementSibling.children[0];
						}

						//close the dropdown but block focus
						navigation_close_dropdown(dropdown, next_element);
					break;
				}
			}
		}
	}

	function navigation_close_dropdown(dropdown = false, focus = true) {
			
		//remove the toggle class
		dropdown.classList.remove('keyboard-nav-toggle');

		//if we're going to focus on something
		if(focus) {

			//focus on the link
			focus.focus();
		}

		//if we were in the sub menu
		if(sub_menu_open) {

			//close the sub menu
			sub_menu_open = false;
		} else { //otherwise we were in the parent menu

			//close both
			menu_open = false;
			sub_menu_open = false;
		}
	}

	document.getElementsByTagName('header')[0].addEventListener('keydown', navigation_keyboard_traversal);
	document.getElementById('mobile-menu').addEventListener('keydown', navigation_keyboard_traversal);
});